var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectService, injectable } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { UserService } from '@/domains/user/services/user-service.interface';
import { ProductMap, ProductMapReverse } from '@/domains/user/enums';
import { UserSettingService } from '@/domains/user/services/user-setting-service.interface';
import { I18nService } from '@/services/i18n-service';
export const LinkJumpSelectServiceSymbol = Symbol.for('LinkJumpSelectService');
let LinkJumpSelectService = class LinkJumpSelectService {
    constructor(userService, _userSettingService) {
        this.userService = userService;
        this._userSettingService = _userSettingService;
        // Detail | Task
        this.currentTarget = 'Detail';
        this._showLinkJumpSettingsDialog = false;
        this.showLinkJumpSettingsDialogParams = null;
        this.showLinkJumpSettingsSuccess = false;
    }
    // pro | eureka
    get goToWhichProductLinkOrigin() {
        return this._userSettingService.userSetting?.go_to_where;
    }
    // 入参 pro | eureka
    set goToWhichProductLinkOrigin(val) {
        this._userSettingService.updateUserSettingGoToWhere(val);
    }
    // Analytics | Eureka
    get goToWhichProductLink() {
        const productOrigin = this._userSettingService.userSetting?.go_to_where;
        return ProductMapReverse[productOrigin];
    }
    // 入参Analytics | Eureka
    set goToWhichProductLink(val) {
        const productOrigin = ProductMap[val];
        this.goToWhichProductLinkOrigin = productOrigin;
    }
    get productList() {
        return this.userService.userInfo.product_list || [];
    }
    get showLinkJumpSettingsDialog() {
        return this._showLinkJumpSettingsDialog;
    }
    set showLinkJumpSettingsDialog(val) {
        this._showLinkJumpSettingsDialog = val;
        if (!val)
            this.showLinkJumpSettingsDialogParams = null;
    }
    openLinkJumpSettingsDialog(params) {
        this._showLinkJumpSettingsDialog = true;
        this.showLinkJumpSettingsDialogParams = params;
    }
    get imgSuffix() {
        const i18n = injectService(I18nService);
        return ['cn', 'tw'].includes(i18n.locale) ? 'cn' : 'us';
    }
    get CAROUSELS() {
        const i18n = injectService(i18nSymbol);
        return {
            ANALYTICS: [
                {
                    text: i18n.t('linkJumpSelect.previewPatent'),
                    img: `analytics-patent-${this.imgSuffix}.png`,
                },
                {
                    text: i18n.t('linkJumpSelect.previewLiterature'),
                    img: `analytics-paper-${this.imgSuffix}.png`,
                },
            ],
            EUREKA: [
                {
                    text: i18n.t('linkJumpSelect.previewPatent'),
                    img: `eureka-patent-${this.imgSuffix}.png`,
                },
                {
                    text: i18n.t('linkJumpSelect.previewLiterature'),
                    img: `eureka-paper-${this.imgSuffix}.png`,
                },
            ],
            SYNAPSE: [
                {
                    text: i18n.t('linkJumpSelect.previewPatent'),
                    img: `synapse-patent-${this.imgSuffix}.png`,
                },
                {
                    text: i18n.t('linkJumpSelect.previewLiterature'),
                    img: `synapse-paper-${this.imgSuffix}.png`,
                },
            ],
        };
    }
};
LinkJumpSelectService = __decorate([
    injectable(),
    __param(0, inject(UserService)),
    __param(1, inject(UserSettingService)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserService !== "undefined" && UserService) === "function" ? _a : Object, typeof (_b = typeof UserSettingService !== "undefined" && UserSettingService) === "function" ? _b : Object])
], LinkJumpSelectService);
export { LinkJumpSelectService };
